import NextImage from "next/image";
import ThumborJS from "thumborjs";
import Link from "next/link";
const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const App = ({ content, queryParam }) => {
  const myLoader = ({ src, width }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen
        .imgpath(src)
        .resize(width, 0)
        .filter("format(webp)")
        .genurl();

      return url;
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 justify-center">
      {content?.map((content, index) => {
        return (
          <Link
            key={`content-3-${index}`}
            prefetch={false}
            href={`${content?.url}${queryParam ? `?${queryParam}` : ``}`}
          >
            <div className="card-third">
              <div className="relative w-full aspect-[600/899]">
                <NextImage
                  loader={myLoader}
                  src={`${imageUrl}${content?.image_path.replace(
                    /\/uploads/g,
                    ""
                  )}`}
                  alt={content?.title}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  placeholder="blur"
                  blurDataURL={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=`}
                />
              </div>
              <div className="body">
                <p className="h2 title">{`${content?.title}`}</p>
                <p className="h5 desc">Shop Now</p>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default App;
